import { Button, Carousel, Col, Row } from "react-bootstrap"
import { url_images } from "../../lib/backend/data"
import { FaFacebook, FaInstagram, FaLinkedin, FaRegEnvelope, FaTelegramPlane, FaTiktok, FaWhatsapp, FaYoutube } from "react-icons/fa"
import { FaXTwitter } from "react-icons/fa6"

const { useSelector } = require("react-redux")

const SocialIcons = props => {
    const {
        zone
    } = props
    const sitio = useSelector(state => state.sitio)

    if(sitio.modules[zone]?.active !== true) return null
    const items = [
        { key: "instagram", icon: <FaInstagram />  },
        { key: "facebook", icon: <FaFacebook />  },
        { key: "twitter", icon: <FaXTwitter />  },
        { key: "youtube", icon: <FaYoutube />  },
        { key: "whatsapp", icon: <FaWhatsapp />  },
        { key: "tiktok", icon: <FaTiktok />  },
        { key: "linkedin", icon: <FaLinkedin />  },
        { key: "telegram", icon: <FaTelegramPlane />  },
        { key: "email", icon: <FaRegEnvelope />  },
    ]
    
    
    return <div>
        <h6>Síguenos en nuestras redes</h6>
        {
            items.map((item, index) => {
                if(!sitio.modules[zone]?.items[item.key]?.value) return null
                return <a key={index} href={sitio.modules[zone]?.items[item.key]?.value} target="_blank" rel="noopener noreferrer" className="me-2 mr-2" style={{ display: "inline-block" }}>
                    <div className="d-flex justify-content-center align-items-center" style={{ fontSize: 25 }} >
                        {item.icon}
                    </div>
                </a>
            })
        }
    </div>
}

export default SocialIcons